"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationHeader = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const LanguageProvider_1 = require("../../i18n/LanguageProvider");
const TextResources_1 = require("../../i18n/TextResources");
const Avatar_1 = require("../../sharedComponents/Avatar");
const theme_1 = require("../../theme");
const store_1 = require("../store");
const ConversationBase_1 = require("./ConversationBase");
const ConversationHeader = ({ ProfileButton, backButton = null, renderRightButton, }) => {
    var _a;
    const conversationPartner = store_1.useConversationPartner();
    const translateContext = react_1.useContext(LanguageProvider_1.LanguageContext);
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        backButton,
        react_1.default.createElement(ProfileButton, { profile: conversationPartner },
            react_1.default.createElement(ConversationBase_1.ConversationBase, { image: (conversationPartner === null || conversationPartner === void 0 ? void 0 : conversationPartner.imageUrl) ? (react_1.default.createElement(Avatar_1.Avatar, { imageUri: conversationPartner.imageUrl })) : null },
                react_1.default.createElement(react_native_1.View, { style: styles.nameWrapper },
                    react_1.default.createElement(react_native_1.Text, { style: styles.name }, (_a = conversationPartner === null || conversationPartner === void 0 ? void 0 : conversationPartner.name) !== null && _a !== void 0 ? _a : TextResources_1.getTextResource(translateContext.currentLanguage).mailbox
                        .noConversationSelected)))),
        conversationPartner ? renderRightButton === null || renderRightButton === void 0 ? void 0 : renderRightButton(conversationPartner) : null));
};
exports.ConversationHeader = ConversationHeader;
const styles = react_native_1.StyleSheet.create({
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        zIndex: 1,
    },
    name: {
        fontFamily: theme_1.fontFamily,
        fontSize: 17,
        fontWeight: '500',
    },
    nameWrapper: {
        flex: 1,
        justifyContent: 'center',
        minHeight: 50,
    },
});
